import commonUtil from './../../../utils/commonUtil';

export const ACCOUNTSTATUS_LOAD = 'ACCOUNTSTATUS_LOAD';
export const ACCOUNTSTATUS_LOAD_SUCCESS = 'ACCOUNTSTATUS_LOAD_SUCCESS';
export const ACCOUNTSTATUS_LOAD_FAIL = 'ACCOUNTSTATUS_LOAD_FAIL';

export const INTRANSIT_LOAD = 'INTRANSIT_LOAD';
export const INTRANSIT_LOAD_SUCCESS = 'INTRANSIT_LOAD_SUCCESS';
export const INTRANSIT_LOAD_FAIL = 'INTRANSIT_LOAD_FAIL';

export const PURCHASEDITEMSUMMARYINFO_LOAD = 'PURCHASEDITEMSUMMARYINFO_LOAD';
export const PURCHASEDITEMSUMMARYINFO_LOAD_SUCCESS = 'PURCHASEDITEMSUMMARYINFO_LOAD_SUCCESS';
export const PURCHASEDITEMSUMMARYINFO_LOAD_FAIL = 'PURCHASEDITEMSUMMARYINFO_LOAD_FAIL';

export const PURCHASEDITEMDETAILS_LOAD = 'PURCHASEDITEMDETAILS_LOAD';
export const PURCHASEDITEMDETAILS_LOAD_SUCCESS = 'PURCHASEDITEMDETAILS_LOAD_SUCCESS';
export const PURCHASEDITEMDETAILS_LOAD_FAIL = 'PURCHASEDITEMDETAILS_LOAD_FAIL';

export const BONUSDETAILS_LOAD = 'BONUSDETAILS_LOAD';
export const BONUSDETAILS_LOAD_SUCCESS = 'BONUSDETAILS_LOAD_SUCCESS';
export const BONUSDETAILS_LOAD_FAIL = 'BONUSDETAILS_LOAD_FAIL';

export const STATEMENTDETAILSFORPRINTANDDOWNLOAD_LOAD = 'STATEMENTDETAILSFORPRINTANDDOWNLOAD_LOAD';
export const STATEMENTDETAILSFORPRINTANDDOWNLOAD_LOAD_SUCCESS = 'STATEMENTDETAILSFORPRINTANDDOWNLOAD_LOAD_SUCCESS';
export const STATEMENTDETAILSFORPRINTANDDOWNLOAD_LOAD_FAIL = 'STATEMENTDETAILSFORPRINTANDDOWNLOAD_LOAD_FAIL';

export const SUBMIT_TRANCEFERENCE_LOAD = 'SUBMIT_TRANCEFERENCE_LOAD';
export const SUBMIT_TRANCEFERENCE_LOAD_SUCCESS = 'SUBMIT_TRANCEFERENCE_LOAD_SUCCESS';
export const SUBMIT_TRANCEFERENCE_LOAD_FAIL = 'SUBMIT_TRANCEFERENCE_LOAD_FAIL';

export function getEventAccountStatementDetails(eventId) {
  const _accountStatusInput = {};
  _accountStatusInput.brand = commonUtil.getBrand();
  _accountStatusInput.channel = commonUtil.getChannel();
  _accountStatusInput.eventId = eventId;
  return {
    types: [ACCOUNTSTATUS_LOAD, ACCOUNTSTATUS_LOAD_SUCCESS, ACCOUNTSTATUS_LOAD_FAIL],
    promise: client => client.post('/api/getEventAccountStatementDetails', {
      data: (_accountStatusInput),
    }),
  };
}

export function getInTransitDetails(eventId) {
  const _intransitInput = {};
  _intransitInput.brand = commonUtil.getBrand();
  _intransitInput.channel = commonUtil.getChannel();
  _intransitInput.eventId = eventId;
  return {
    types: [INTRANSIT_LOAD, INTRANSIT_LOAD_SUCCESS, INTRANSIT_LOAD_FAIL],
    promise: client => client.post('/api/getInTransitDetails', {
      data: (_intransitInput),
    }),
  };
}

export function getPurchasedItemSummaryInfo(eventId, type) {
  const _inputs = {};
  _inputs.brand = commonUtil.getBrand();
  _inputs.channel = commonUtil.getChannel();
  _inputs.eventId = eventId;
  _inputs.type = type;
  return {
    types: [PURCHASEDITEMSUMMARYINFO_LOAD, PURCHASEDITEMSUMMARYINFO_LOAD_SUCCESS, PURCHASEDITEMSUMMARYINFO_LOAD_FAIL],
    promise: client => client.post('/api/getPurchasedItemSummaryInfo', {
      data: (_inputs),
    }),
  };
}

export function getPurchasedItemsDetails(eventId, type, filteringParameters, sortingParameters, currentPage, isShowAll) {
  const _inputs = {};
  _inputs.brand = commonUtil.getBrand();
  _inputs.channel = commonUtil.getChannel();
  _inputs.eventId = eventId;
  _inputs.type = type;
  _inputs.filteringParameters = filteringParameters;
  _inputs.sortingParameters = sortingParameters;
  _inputs.currentPage = currentPage;
  _inputs.isShowAll = isShowAll;
  return {
    types: [PURCHASEDITEMDETAILS_LOAD, PURCHASEDITEMDETAILS_LOAD_SUCCESS, PURCHASEDITEMDETAILS_LOAD_FAIL],
    promise: client => client.post('/api/getPurchasedItemsDetails', {
      data: (_inputs),
    }),
  };
}

export function getBonusDetails(eventId) {
  const _bonusDetailInput = {};
  _bonusDetailInput.brand = commonUtil.getBrand();
  _bonusDetailInput.channel = commonUtil.getChannel();
  _bonusDetailInput.eventId = eventId;
  return {
    types: [BONUSDETAILS_LOAD, BONUSDETAILS_LOAD_SUCCESS, BONUSDETAILS_LOAD_FAIL],
    promise: client => client.post('/api/getBonusDetails', {
      data: (_bonusDetailInput),
    }),
  };
}

export function getAccountPartialTransferDetails(eventId) {
  const _accountPartialTransferInput = {};
  _accountPartialTransferInput.brand = commonUtil.getBrand();
  _accountPartialTransferInput.channel = commonUtil.getChannel();
  _accountPartialTransferInput.eventId = eventId;
  return commonUtil.triggerServerRequest({ url: '/api/getAccountPartialTransferDetails', method: 'POST', data: _accountPartialTransferInput });
}

export function getStatementDetailsForPrintAndDownload(eventId) {
  const _input = {
    channel: commonUtil.getChannel(),
    brand: commonUtil.getBrand(),
    eventId,
  };
  return {
    types: [STATEMENTDETAILSFORPRINTANDDOWNLOAD_LOAD, STATEMENTDETAILSFORPRINTANDDOWNLOAD_LOAD_SUCCESS, STATEMENTDETAILSFORPRINTANDDOWNLOAD_LOAD_FAIL],
    promise: client => client.post('/api/getStatementDetailsForPrintAndDownload', {
      data: (_input),
    }),
  };
  // return commonUtil.triggerServerRequest({ url: '/api/getStatementDetailsForPrintAndDownload', method: 'POST', data: values });
}

export function checkLoginValid(loginForm) {
  const _loginFormInput = {};
  _loginFormInput.brandName = commonUtil.getBrand();
  _loginFormInput.channel = commonUtil.getChannel();
  _loginFormInput.email = loginForm.login;
  _loginFormInput.password = loginForm.password;
  return commonUtil.triggerServerRequest({ url: '/api/reAuthenticateUser', method: 'POST', data: _loginFormInput });
}

export function getTransferenceOptions(eventId, eventOwnerId, type, activatePhysicalWallet, activeDigitalWallet) {
  const loadTrasnFerenceData = {
    brand: commonUtil.getBrand(),
    channel: commonUtil.getChannel(),
    eventId,
    eventOwnerId,
    type,
    activatePhysicalWallet,
    activeDigitalWallet,
  };
  return commonUtil.triggerServerRequest({ url: '/api/getTransferenceOptions', method: 'POST', data: loadTrasnFerenceData });
}

export function submitTransference(submitransferenceRequestData) {
  const submitransferenceData = {
    brand: commonUtil.getBrand(),
    channel: commonUtil.getChannel(),
    ...submitransferenceRequestData,
  };
  return commonUtil.triggerServerRequest(
    {
      url: '/api/submitTransference',
      method: 'POST',
      data: submitransferenceData,
    },
  );
}

export function calculateCommision(eventId, accountType, walletType, amount, accountId) {
  const calculateCommisionData = {
    brand: commonUtil.getBrand(),
    channel: commonUtil.getChannel(),
    eventId,
    accountType,
    walletType,
    amount,
    accountId,
  };
  return commonUtil.triggerServerRequest({ url: '/api/calculateCommision', method: 'POST', data: calculateCommisionData });
}

export function deleteBankOrCardDetails(accountId) {
  const deleteBankOrCardDetailsData = {
    brand: commonUtil.getBrand(),
    channel: commonUtil.getChannel(),
    accountId,
  };
  return commonUtil.triggerServerRequest({ url: '/api/deleteBankOrCardDetails', method: 'POST', data: deleteBankOrCardDetailsData });
}

export function saveBankOrCardDetails(accountId) {
  const saveBankOrCardData = {
    brand: commonUtil.getBrand(),
    channel: commonUtil.getChannel(),
    accountId,
  };
  return commonUtil.triggerServerRequest({ url: '/api/saveBankOrCardDetails', method: 'POST', data: saveBankOrCardData });
}

export function getEwalletInfo(profileId) {
  const values = {
    brandName: commonUtil.getBrand(),
    channel: commonUtil.getChannel(),
    profileId,
  };
  return commonUtil.triggerServerRequest({ url: '/api/getEwalletInfo', method: 'POST', data: values });
}

export function initiateEventCloseProcess(eventId) {
  const values = {
    brand: commonUtil.getBrand(),
    channel: commonUtil.getChannel(),
    eventId,
  };
  return commonUtil.triggerServerRequest({ url: '/api/initiateEventCloseProcess', method: 'POST', data: values });
}

export function sendMail(eventId, fileName, data, emailId) {
  const values = {
    brand: commonUtil.getBrand(),
    channel: commonUtil.getChannel(),
    eventId,
    emailId,
  };
  return commonUtil.triggerServerRequest({ url: '/api/sendMail', method: 'POST', data: values });
}

export function getOpeningOrClosingGiftForEvent(eventId) {
  const values = {
    brand: commonUtil.getBrand(),
    channel: commonUtil.getChannel(),
    eventId,
    type: 'closing',
  };

  return commonUtil.triggerServerRequest({ url: '/api/EditEvent/getOpeningOrClosingGiftForEvent', method: 'POST', data: values });
}

export function getEventDeliveryAddresses(eventId) {
  const values = {
    brand: commonUtil.getBrand(),
    channel: commonUtil.getChannel(),
    eventId,
  };
  return commonUtil.triggerServerRequest({ url: '/api/EventDeliveryAddresses', method: 'POST', data: values });
}

export function authenticateOTP(userName) {
  // ----- CHECK: QA or Dev or Prod -----
  const authenticateOtpData = {
    brand: commonUtil.getBrand(),
    channel: commonUtil.getChannel(),
    username: userName,
    password: "",
  };
  return commonUtil.triggerServerRequest(
    {
      url: '/api/authenticateOTP',
      method: 'POST',
      data: authenticateOtpData,
    },
  );
}

export function searchOtpUser(profileId, token) {
  const searchOtpUserData = {
    brand: commonUtil.getBrand(),
    channel: commonUtil.getChannel(),
    profileId,
    token,
  };
  return commonUtil.triggerServerRequest(
    {
      url: '/api/otpSearchUser',
      method: 'POST',
      data: searchOtpUserData,
    },
  );
}

export function createOtpUser(profileId, token) {
  const profileIdOtpData = {
    brand: commonUtil.getBrand(),
    channel: commonUtil.getChannel(),
    profileId,
    token,
  };
  return commonUtil.triggerServerRequest(
    {
      url: '/api/createOtpUser',
      method: 'POST',
      data: profileIdOtpData,
    },
  );
}

export function createOtpDevice(profileId, token) {
  const profileIdOtpData = {
    brand: commonUtil.getBrand(),
    channel: commonUtil.getChannel(),
    profileId,
    token,
  };
  return commonUtil.triggerServerRequest(
    {
      url: '/api/createOtpDevice',
      method: 'POST',
      data: profileIdOtpData,
    },
  );
}

export function createOtpCode(profileId, eventNumber, token) {
  const profileIdOtpData = {
    brand: commonUtil.getBrand(),
    channel: commonUtil.getChannel(),
    empresa: 'LIV',
    profileId,
    token,
    eventNumber,
  };
  return commonUtil.triggerServerRequest(
    {
      url: '/api/createOtpCode',
      method: 'POST',
      data: profileIdOtpData,
    },
  );
}

export function validateOtpCode(profileId, otp, token) {
  const profileIdOtpData = {
    brand: commonUtil.getBrand(),
    channel: commonUtil.getChannel(),
    profileId,
    otp,
    token,
  };
  return commonUtil.triggerServerRequest(
    {
      url: '/api/validateOtpCode',
      method: 'POST',
      data: profileIdOtpData,
    },
  );
}
